// CommentPlaceholder.tsx
import React, { useState } from 'react';
import TagList from '../Common/TagList';
import CommentContent from '../Common/CommentContent';
import AdditionalUserInformation from './AdditionalUserInformation';
import HighlightToggle from '../Common/HighlightToggle';
import './CommentPlaceholder.css';
import commentHighlightingIcon from '../../images/comment_highlighting.svg';
import { Sentence, Tag as TagType } from '../../types/types';
import { logEvent } from '../../utils/Logger';
import { usernames } from '../../data/highlightedUsernames';
import { create } from 'domain';

interface TagMatch {
  tag: string;
  text: string;
}

interface CommentPlaceholderProps {
  depth: number;
  author: string;
  content: string;
  tagMatch?: TagMatch | TagMatch[];
  tags: TagType[];
  explanation?: string; // Add this line
  sentences?: Sentence[];
  onReply: () => void;
  commentId: number;
  createdAt: string;
}

const CommentPlaceholder: React.FC<CommentPlaceholderProps> = ({
  depth,
  author,
  content,
  tagMatch,
  tags,
  explanation, // Add this line
  sentences,
  onReply,
  commentId: id,
  createdAt
}) => {
  const [isHighlightEnabled, setIsHighlightEnabled] = useState(false);
  const isCommentHighlighted = usernames.includes(author);
  const isCommentHighlightedClass = isCommentHighlighted ? 'comment--highlighted' : '';     
  const toggleHighlight = () => {
    const eventName = isHighlightEnabled ? 'disable_highlight' : 'enable_highlight';
    setIsHighlightEnabled(!isHighlightEnabled);
    const payload = {
      comment_id: id,
    }
    logEvent(eventName, JSON.stringify(payload), window.location.href);
  }


  const depthClass = `depth-${Math.min(depth, 6)}`;

  // Transform sentences to tagMatch
  const transformedTagMatch: TagMatch[] = sentences?.map(sentence => ({
    tag: sentence.frame,
    text: sentence.text,
    explanation: sentence.explanation
  })) || [];

  const [highlightedTag, setHighlightedTag] = useState<string>('');

  const onTagHover = (tag: TagType) => {
    const eventName = 'onTagHover';
    const payload = {
      comment_id: id,
      tag: tag.frame,
    }
    logEvent(eventName, JSON.stringify(payload), window.location.href);
    setHighlightedTag(tag.frame);
  }

  const onTagHoverOut = () => {
    const eventName = 'onTagHoverOut';
    const payload = {
      comment_id: id,
      tag: highlightedTag
    }
    logEvent(eventName, JSON.stringify(payload), window.location.href);
    setHighlightedTag('');
  }

  return (
    <div className={`comment ${depthClass} ${isCommentHighlightedClass}`}>
      <div className="comment-header">
        <div className="comment-author-tags">
          <span className="author">{author}</span>
          <TagList tags={tags} onTagHover={onTagHover} onTagHoverOut={onTagHoverOut} />
        </div>
        <div className="comment-controls">
          <HighlightToggle isEnabled={isHighlightEnabled} onToggle={toggleHighlight} />
          {/* <AdditionalUserInformation 
            explanation={explanation}/> */}
        </div>
        <div className="timestamp--container">
          <span className="timestamp">{new Date(createdAt + 'Z').toLocaleString()}</span>
        </div>
      </div>
      <CommentContent 
        content={content} 
        tagMatch={transformedTagMatch || []} 
        isHighlightEnabled={isHighlightEnabled} 
        highlightedFrame={highlightedTag}
      />
      <div className="comment-footer">
        <button className="reply-button" onClick={onReply}>
          <img src={commentHighlightingIcon} alt="Reply" width="16" height="16" />
          Reply
        </button>
      </div>
    </div>
  );
};

export default CommentPlaceholder;